import { useQuery } from "@tanstack/react-query";
import type { CustomerStatisticsParams } from "./statisticsApi";
import { getCustomerStatistics } from "./statisticsApi";

export function useCustomerStatistics(customerId: string | null, params: CustomerStatisticsParams) {
  return useQuery({
    queryKey: ["admin", "statistics", "customers", customerId, params],
    queryFn: ({ signal }) => getCustomerStatistics(customerId as string, params, signal),
    enabled: customerId !== null,
  });
}
